import React from "react";
import Hero from "../../components/Hero/Hero";
import SellerValueProp from "../../components/SellerValueProp/SellerValueProp";
import FeaturedModels from "../../components/FeaturedModels/FeaturedModels";
import BlogTeaser from "../../components/BlogTeaser/BlogTeaser";
import { useSEO, SEO_META } from "../../hooks/useSEO";
import { useLanguage } from "../../context/LanguageContext";
import styles from "./Home.module.css";

const Home = () => {
  const { t } = useLanguage();

  // SEO optimizasyonu
  useSEO({
    ...SEO_META.HOME,
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "3DEra",
      "description": t('home.seoDesc'),
      "url": "https://3dera.io",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://3dera.io/marketplace?search={search_term_string}",
        "query-input": "required name=search_term_string"
      },
      "publisher": {
        "@type": "Organization",
        "name": "3DEra",
        "url": "https://3dera.io"
      }
    }
  });

  return (
    <div className={styles.home}>
      <Hero />
      <SellerValueProp />
      <FeaturedModels />
      <BlogTeaser />
    </div>
  );
};

export default Home; 